import { Box, Drawer } from '@mui/material';
import { FC, ReactNode, useEffect } from 'react';
import { useShowDrawer } from '../../contexts';

interface Props {
    children?: ReactNode;
}

export const SideBar: FC<Props> = ({ children }) => {
    const { showDrawer, setShowDrawer, setHasDrawer } = useShowDrawer();
    const handleDrawerToggle = () => {
        setShowDrawer(!showDrawer);
    };

    useEffect(() => {
        setHasDrawer(true);
        return () => setHasDrawer(false);
    }, [setHasDrawer]);

    return (
        <Box>
            <Drawer
                sx={{ '.MuiDrawer-paper': { top: 55, pb: 6 }, display: { xs: 'block', lg: 'none' } }}
                variant="temporary"
                open={showDrawer}
                onClose={handleDrawerToggle}
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                }}
            >
                <Box onClick={handleDrawerToggle}>{children}</Box>
            </Drawer>

            <Drawer
                sx={{ '.MuiDrawer-paper': { top: 55, pb: 6 }, display: { xs: 'none', lg: 'block' } }}
                variant="persistent"
                open
            >
                <Box>{children}</Box>
            </Drawer>
        </Box>
    );
};
